<template>
  <div class="min-h-screen flex items-center justify-center bg-slate-50 p-6">
    <div class="max-w-2xl w-full rounded-2xl border border-slate-200 bg-white p-8 shadow-sm text-center">
      <div class="mx-auto mb-4 h-12 w-12 rounded-full bg-amber-100 flex items-center justify-center">
        <span class="text-amber-700 text-2xl">!</span>
      </div>

      <h1 class="text-2xl md:text-3xl font-semibold text-slate-900">Sitio temporalmente no habilitado</h1>
      <p class="mt-3 text-slate-600">
        La inmobiliaria
        <strong>{{ inmobiliariaNombre || 'seleccionada' }}</strong>
        no tiene una suscripción activa.
      </p>
      <p class="mt-2 text-slate-600">
        Para habilitar este sitio, el administrador debe activar o regularizar la suscripción.
      </p>

      <p class="mt-6 text-sm text-slate-500">
        Si creés que esto es un error, por favor contactá al administrador de la inmobiliaria.
      </p>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'SubscriptionInactiveGate',
  computed: {
    ...mapState({
      accessControl: state => state.accessControl,
    }),
    inmobiliariaNombre() {
      return this.accessControl?.inmobiliaria?.nombre || ''
    },
  },
}
</script>
